module.exports = __webpack_public_path__ + "static/media/custom.723e5495.svg";